import React, { useState } from "react";
import CategoryTag from "./CategoryTag";
import EditTaskForm from "./EditTaskForm";
import { useFirebase } from "../../database/FirebaseContext";

function ListItem({ openModal, task, colourBlindMode }) {
    const { deletePBTask } = useFirebase();

    // function to open the modal for a specific item
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal2 = () => {
        setIsModalOpen(true);
    };

    // function to close the modal
    const closeModal = () => {
        setIsModalOpen(false);
    };

    const getSPBackgroundColor = (colourBlindMode) => {
        switch (colourBlindMode) {
            case true:
                return "bg-[#D1D9FA]"
            default:
                return "bg-[#b7e1f9]";
        }
      };

      const getPriorityBackgroundColor = (colourBlindMode, priority) => {
        if (colourBlindMode === true) {
            switch (priority) {
                case 1:
                    return "bg-[#A2E365]";
                case 2:
                    return "bg-[#F3F38B]";
                case 3:
                    return "bg-[#D27D23]";
                default:
                    return "bg-[#C96514]";
            }
        }
        else {
            switch (priority) {
                case 1:
                    return "bg-[#00FF19]";
                case 2:
                    return "bg-[#DDFF0A]";
                case 3:
                    return "bg-[#FA632D]";
                default:
                    return "bg-[#ff3528]";
            }
        }
      };




    return (
        <div class="list-item">
            <div class="card text-white bg-dark list-item-container">
                <div class="card-header list-item-header">
                    <span class="list-item-title">{task.taskName}</span>
                    <div class="list-item-icon">
                        <i
                            class="fa-regular fa-pen-to-square fa-lg list-item-icon"
                            onClick={() => openModal2(task)}
                        ></i>
                        <i
                            class="fa-regular fa-trash-can fa-lg list-item-icon"
                            onClick={() => deletePBTask(task.id)}
                        ></i>
                    </div>
                </div>
                <div
                    class="card-body list-item-body"
                    onClick={() => openModal(task)}
                >
                    <div class={`${getSPBackgroundColor(colourBlindMode)} storypoint-badge`}>
                        <span>Story Point: {task.taskStoryPoint}</span>
                    </div>
                    <>
                        {task.taskPriority === 4 && (
                            <div className={`${getPriorityBackgroundColor(colourBlindMode, task.taskPriority)} priority-badge`}>
                                <span>{"Urgent"}</span>
                            </div>
                        )}

                        {task.taskPriority === 1 && (
                            <div
                                className= {`${getPriorityBackgroundColor(colourBlindMode, task.taskPriority)} priority-badge`}
                            >
                                <span>{"Low"}</span>
                            </div>
                        )}

                        {task.taskPriority === 2 && (
                            <div
                                className={`${getPriorityBackgroundColor(colourBlindMode, task.taskPriority)} priority-badge`}
                            >
                                <span>{"Medium"}</span>
                            </div>
                        )}

                        {task.taskPriority === 3 && (
                            <div
                                className={`${getPriorityBackgroundColor(colourBlindMode, task.taskPriority)} priority-badge`}
                            >
                                <span>{"Important"}</span>
                            </div>
                        )}
                    </>

                    {task.taskTag.map((tag, index) => (
                        <CategoryTag key={index} category={tag} />
                    ))}
                </div>
            </div>
            {isModalOpen && (
                <EditTaskForm task={task} closeModal={closeModal} />
            )}
        </div>
    );
}

export default ListItem;
